import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ChartBarIcon,
  DocumentTextIcon,
  CurrencyRupeeIcon,
  ClockIcon,
  CalendarIcon,
  GiftIcon,
  DocumentDownloadIcon,
} from "@heroicons/react/outline";

const ReportsHub = () => {
  const navigate = useNavigate();

  const reports = [
    {
      title: "Daily Collections",
      description: "View and export daily payment collections",
      icon: CurrencyRupeeIcon,
      color: "bg-success",
      lightColor: "bg-success-light",
      path: "/jewellery/reports/daily-collections",
    },
    {
      title: "Pending Verifications",
      description: "Payments awaiting verification",
      icon: ClockIcon,
      color: "bg-warning",
      lightColor: "bg-warning-light",
      path: "/jewellery/reports/pending-verifications",
    },
    {
      title: "Overdue Report",
      description: "Plans with overdue installments",
      icon: DocumentTextIcon,
      color: "bg-danger",
      lightColor: "bg-danger-light",
      path: "/jewellery/reports/overdues",
    },
    {
      title: "Maturity Report",
      description: "Upcoming and recent plan maturities",
      icon: CalendarIcon,
      color: "bg-secondary",
      lightColor: "bg-secondary-light",
      path: "/jewellery/reports/maturities",
    },
    {
      title: "Redemption Analytics",
      description: "Redemption patterns and statistics",
      icon: GiftIcon,
      color: "bg-primary",
      lightColor: "bg-primary-light",
      path: "/jewellery/reports/redemptions",
    },
    {
      title: "Export Center",
      description: "Export data in various formats",
      icon: DocumentDownloadIcon,
      color: "bg-neutral-dark",
      lightColor: "bg-neutral-light",
      path: "/jewellery/reports/export",
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-background shadow rounded-lg p-6 mb-6">
        <h1 className="text-2xl font-bold text-text">Reports Center</h1>
        <p className="mt-1 text-sm text-neutral-dark">
          Generate and export various reports for analysis
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reports.map((report) => (
          <div
            key={report.path}
            onClick={() => navigate(report.path)}
            className="bg-background rounded-lg shadow hover:shadow-lg transition-shadow cursor-pointer p-6 group"
          >
            <div className="flex items-start">
              <div className={`${report.color} rounded-lg p-3 mr-4 group-hover:scale-110 transition-transform`}>
                <report.icon className="h-6 w-6 text-text-on-primary" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-medium text-text">
                  {report.title}
                </h3>
                <p className="mt-1 text-sm text-neutral-dark">
                  {report.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportsHub;
